@import "../../common/base-mixins";
@import "../../global/tokens";

@include box-sizing();

:host {
  display: block;
  height: 100vh;
  width: var(--gx-sidebar-expanded);
  box-sizing: border-box;

  display: grid;
  grid-template-rows: 1fr auto;
  overflow: hidden;
  transition: width 0.25s ease;

  box-shadow: var(--gx-shadow-md);
}

:host([is-collapsed]) {
  overflow: hidden;
  width: var(--gx-sidebar-collapsed);
  .wrapper {
    visibility: hidden;
  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  min-width: var(--gx-sidebar-expanded);
}
.header-wrapper {
  flex-basis: 40px;
  flex-grow: 0;
  flex-shrink: 0;
}

// ::slotted([slot="header"]) {
//   background-color: aqua;
// }
.main-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.btn {
  cursor: pointer;
  height: 100%;
}

.btn-resize {
  border: 0;
  padding: 0;
  width: var(--gx-sidebar-collapsed);
  flex-basis: 40px;
  /**/
  background-color: currentColor;
  -webkit-mask-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor"><path d="M 16.25 1.34375 L 7.25 11.34375 L 6.65625 12 L 7.25 12.65625 L 16.25 22.65625 L 17.75 21.34375 L 9.34375 12 L 17.75 2.65625 Z"/></svg>');
  -webkit-mask-position: center center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 60%;
}
.btn-resize--expanded {
  transform: scaleX(-1);
}
.btn-new-chat {
  align-items: center;
  background-color: inherit;
  border: none;
  display: flex;
  gap: 0.5em;
  padding: 0 1em;
}
.btn-new-chat::before {
  content: "";
  cursor: pointer;
  display: block;
  width: 16px;
  height: 16px;
  /**/
  background-color: currentColor;
  -webkit-mask-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24px" height="24px" fill="currentColor"><path d="M 25 4.0625 C 12.414063 4.0625 2.0625 12.925781 2.0625 24 C 2.0625 30.425781 5.625 36.09375 11 39.71875 C 10.992188 39.933594 11 40.265625 10.71875 41.3125 C 10.371094 42.605469 9.683594 44.4375 8.25 46.46875 L 7.21875 47.90625 L 9 47.9375 C 15.175781 47.964844 18.753906 43.90625 19.3125 43.25 C 21.136719 43.65625 23.035156 43.9375 25 43.9375 C 37.582031 43.9375 47.9375 35.074219 47.9375 24 C 47.9375 12.925781 37.582031 4.0625 25 4.0625 Z M 25 5.9375 C 36.714844 5.9375 46.0625 14.089844 46.0625 24 C 46.0625 33.910156 36.714844 42.0625 25 42.0625 C 22.996094 42.0625 21.050781 41.820313 19.21875 41.375 L 18.65625 41.25 L 18.28125 41.71875 C 18.28125 41.71875 15.390625 44.976563 10.78125 45.75 C 11.613281 44.257813 12.246094 42.871094 12.53125 41.8125 C 12.929688 40.332031 12.9375 39.3125 12.9375 39.3125 L 12.9375 38.8125 L 12.5 38.53125 C 7.273438 35.21875 3.9375 29.941406 3.9375 24 C 3.9375 14.089844 13.28125 5.9375 25 5.9375 Z"/></svg>');
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: cover;
}

.footer-wrapper {
  display: flex;
  justify-content: space-between;
  height: 40px;
}

// Scroll
::-webkit-scrollbar {
  width: var(--gx-scrollbar-width);
}
/* Track */
::-webkit-scrollbar-track {
  background: var(--gx-scrollbar-track-color);
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--gx-scrollbar-thumb-color);
  &:hover {
    background: var(--gx-scrollbar-thumb_hover-color);
  }
}
